<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterMethodPayment' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <div
            class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
            v-for="methodPayment in methodPayments"
            :key="methodPayment.id"
          >
            <CardMethodPayment :methodPayment="methodPayment" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardMethodPayment from "@/views/Professional/components/CardMethodPayment";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissionais",
          routerName: "Professional",
        },
        {
          name: "Listar Métodos de Pagamento",
          routerName: "ListMethodPayment",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Professional", ["methodPayments"]),
  },
  components: {
    Breadcrumb,
    CardMethodPayment,
  },
  methods: {
    ...mapActions("Professional", ["consultMethodPayment"]),
  },
  mounted() {
    this.consultMethodPayment();
  },
};
</script>
